'use client';

import type { ReactNode } from 'react';
import type { OutputRenderContext } from '../../tool-config-types';
import { renderPlainTextResult } from '../shared';
import { renderInternalNetworkToolOutputBody } from './ad-tool-output-body';
import { INTERNAL_NETWORK_TOOL_NAMES } from './internal-network-tool-names';
import { McpBloodhoundOutputBody } from './mcp-bloodhound-output-renderer';

function renderWithToolName({
  toolName,
  ctx,
}: {
  toolName: string;
  ctx: OutputRenderContext;
}): ReactNode {
  const body = renderInternalNetworkToolOutputBody({
    toolName,
    output: ctx.content,
  });

  if (body) {
    return body;
  }

  return renderPlainTextResult(ctx);
}

export function renderListAdEntitiesResult(
  ctx: OutputRenderContext,
): ReactNode {
  return renderWithToolName({
    toolName: INTERNAL_NETWORK_TOOL_NAMES.LIST_AD_ENTITIES,
    ctx,
  });
}

export function renderGetAdEntityDetailsResult(
  ctx: OutputRenderContext,
): ReactNode {
  return renderWithToolName({
    toolName: INTERNAL_NETWORK_TOOL_NAMES.GET_AD_ENTITY_DETAILS,
    ctx,
  });
}

export function renderGetAdEntityRelationshipsResult(
  ctx: OutputRenderContext,
): ReactNode {
  return renderWithToolName({
    toolName: INTERNAL_NETWORK_TOOL_NAMES.GET_AD_ENTITY_RELATIONSHIPS,
    ctx,
  });
}

export function renderQueryAdGraphResult(ctx: OutputRenderContext): ReactNode {
  return renderWithToolName({
    toolName: INTERNAL_NETWORK_TOOL_NAMES.QUERY_AD_GRAPH,
    ctx,
  });
}

export function renderDiscoverySignalResult(
  ctx: OutputRenderContext,
): ReactNode {
  return renderWithToolName({
    toolName: INTERNAL_NETWORK_TOOL_NAMES.CREATE_DISCOVERY_SIGNAL,
    ctx,
  });
}

export function renderMcpBloodhoundResult(ctx: OutputRenderContext): ReactNode {
  const text =
    typeof ctx.content === 'string'
      ? ctx.content
      : ctx.content !== undefined && ctx.content !== null
        ? JSON.stringify(ctx.content)
        : '';

  if (!text.trim()) {
    return null;
  }

  return <McpBloodhoundOutputBody output={text} />;
}
